module.exports = __webpack_public_path__ + "img/roa-logo.f7f1a40d.svg";